export default __webpack_public_path__ + "static/product_005-dfad0c3b174423cd93862abf80adf0cd.jpg";